module.exports = __webpack_public_path__ + "37d556f508e51851b367d5f2662f2fef.png";